import React from 'react';
import ReactDOMServer from 'react-dom/server';
import ReactTooltip from 'react-tooltip'
import daimyoList from '../data/daimyolist.json';

export default function showMap() {
  // const sm = window.innerWidth < 640 ? true : false
  const sm = false

  function selectColor(val) {
    switch (val) {
      case "親藩" || 1:
        return "#b7282e"
      case "譜代" || 2:
        return "#b88828"
      case "外様" || 3:
        return "#007083"
      default:
        return "#000000"
    }
  }
  function shinso(val) {
    switch (val) {
      case "親藩":
        return 1
      case "譜代":
        return 2
      case "外様":
        return 3
      default:
        return 2
    }
  }

  return (
    <div class="bg-white p-6 w-full">
      <ReactTooltip effect="float" type="light" place="right" offset="{'right': 10}" className="CustomTooltip" />
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={sm ? "0 0 300 550" : "0 0 550 300"} class="bg-white">
        {daimyoList.filter(el => el["江戸城からの直線距離"]/2).map((el, index) => {
          return (
            <g>
              <circle data-html={true} data-tip={ReactDOMServer.renderToString(<div><span class="text-lg font-bold">{el["藩名（現代通称）"]}藩</span><br />{el["江戸城からの直線距離"].toFixed()}km</div>)}
                key={index}
                // cx={el["江戸城からの直線距離"]/2}
                cx={sm ? shinso(el["親疎（藩翰譜）"]) * 50 : el["江戸城からの直線距離"]/2}
                cy={sm ? el["江戸城からの直線距離"]/2 : shinso(el["親疎（藩翰譜）"]) * 50}
                r={Math.sqrt(el['領知高（単位:石）'] / Math.PI) / 35}
                fill={selectColor(el["親疎（藩翰譜）"])}
                fillOpacity={0.4}
              />
            </g>
          )
        })}
        {[{ cat: "親藩", average_distance: 341.9811058, display_position: 320, color: "#b7282e" }, { cat: "譜代", average_distance: 282.5873678, display_position: 210, color: "#b88828" }, { cat: "外様", average_distance: 543.6494544, display_position: 500, color: "#007083" }].map((el, index) => {
          return (
            <g key={index}>
              <line x1={sm ? (index + 1) * 50 : el.average_distance/2} y1={sm ? el.average_distance/2 : (index + 1) * 50} x2={sm ? "235" : el.average_distance/2} y2={sm ? el.average_distance/2 : "235"} stroke="silver" strokeWidth="1" strokeOpacity="0.5" />
              <text x={sm ? "245" : el.display_position/2} y={sm ? el.display_position/2 : "270"} class="text-sm font-sans font-normal subpixel-antialiased" fill={el.color}>{el.cat}平均</text>
              <text x={sm ? "245" : el.display_position/2} y={sm ? el.display_position/2 + 20 : "255"} class="text-sm font-sans font-light subpixel-antialiased" fill={el.color}>{el.display_position.toFixed()}km</text>
            </g>
          )
        })}
        {[0, 200, 400, 600, 800, 1000].map((el, index) => {
          return (
            <>
              <line x1={sm ? "20" : el/2 + 1} y1={sm ? el/2 + 1 : "20"} x2={sm ? "235" : el/2 + 1} y2={sm ? el/2 + 1 : "200"} stroke="silver" strokeWidth="1" strokeOpacity="0.5" />
              <text x={sm ? "245" : el/2} y={sm ? el/2 + 10 : "220"} class="text-sm font-sans font-light subpixel-antialiased"
              >{el}km</text>
            </>
          )
        })}
      </svg>
    </div>
  )
}